export const CONFIGURATIONS ={
    cantidadLetrasGratis: '10',
    maximoLetrasCajas: '28',
    precioPorFoto: 0.95,
    maximoLargoFraseFoso: '50',
    precioLetraCaja: 1.20,
    tiempoMaximoAudio: 300000,
    tiempoParpadeo: 240,
    precioGrabacion: 25.00
}

export const LINKS_WASAP = {
    formularioPago : 'https://wa.link/96j5vw',
    homePrincipal: 'https://wa.link/96j5vw',
    terminosCondiciones: 'https://1drv.ms/w/c/D65DED447BA12DCC/IQBj63T1DyQ-TpA1iasFLxuMARXzIoSuR3D2kBrtIZ2gCyg?e=GY5aLy'
}

export const PRECIOS_ENVIO = [
    {destino: 'Callao', precio: '10.00'},
    {destino: 'Lima', precio: '10.00'},
    {destino: 'Provincia', precio: '14.00'}  
]
